import singleCoin from 'src/shared/assets/images/single-coin.png'

const AbsoluteCoin = ({ className }: { className: string }) => {
  return (
    <div className={`absolute h-[500px] w-[300px] ${className}`}>
      <img src={singleCoin} alt="Coin" className="size-full object-contain" />
    </div>
  )
}

export default AbsoluteCoin
